import { useTranslation } from 'react-i18next'

const ForceUpdate = () => {
  const { t } = useTranslation('common')
  return (
    <button
      className="flex justify-between items-center py-3"
      onClick={() => window.location.assign('/')}
    >
      <div>
        <p className="font-medium">{t('components.actions.force-update')}</p>
        <p className="text-sm text-gray-500">{t('components.actions.force-update-description')}</p>
      </div>
      <img src="/icons/chevron.svg" width={24} height={24} alt="right chevron" />
    </button>
  )
}

export default ForceUpdate
